var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"private-domain-traffic-page"},[_c('private-domain-traffic',{attrs:{"setting":_vm.setting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }